import { IDefineCommand, IQuery } from 'core-ts-types';
angular
  .module('capability-ng-academic-planner')
  .service(
    'completedAutoGeneratedPreviewPlanShowingCommand',
    ($http: ng.IHttpService, ngPreviewTermPlanConstant: ng.IServiceProvider, log: any, defineCommand: IDefineCommand) =>
      defineCommand('completedAutoGeneratedPreviewPlanShowingCommand', (deferred: ng.IDeferred<IQuery[]>) =>
        $http
          .post(`core/studentvalue`, {
            [ngPreviewTermPlanConstant['AP_PREVIEW_AUTO_GENERATED_TERM_PLAN_SHOWN']]: true
          })
          .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => deferred.resolve(data))
          .catch((e: string) => {
            log.issue('unable to complete intake survey');
            deferred.reject(e);
          })
      )
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/preview_plan/commands/completed_auto_generated_preview_plan_showing_command.ts